const fixedHeader = () => {

    const $window = jQuery(window);

        if ($window.width() > 767) {

        const $fixed_header = jQuery("header");

        if ($window.scrollTop() === 0) {

            $fixed_header.removeClass("minified");

        }

        if ($window.scrollTop() >= $fixed_header.height()) {

            $fixed_header.addClass("minified");

        } else {

            $fixed_header.removeClass("minified");

        }


            }







};
